import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThewashingtonpostComponent } from './simple-icons-thewashingtonpost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThewashingtonpostComponent ],
    exports:      [ SimpleIconsThewashingtonpostComponent ],
    bootstrap:    []
})
export class SimpleIconsThewashingtonpostModule {}
